import axios from "axios";
import store from "~/store";
import router from "~/router";
import Swal from "sweetalert2";
import i18n from "~/plugins/i18n";

// Base URL
// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
let baseURL;
switch (process.env.VUE_APP_API_MODE) {
    case "dev":
        baseURL = process.env.VUE_APP_API_PLATFORM_DEV;
        break;
    case "pre":
        baseURL = process.env.VUE_APP_API_PLATFORM_PRE;
        break;
    default:
        baseURL = process.env.VUE_APP_API_PLATFORM_PROD;
        break;
}

axios.defaults.baseURL = baseURL;

axios.defaults.cancelToken = store.getters["global/requestCancelToken"].token;

// Request interceptor
axios.interceptors.request.use((request) => {
    const token = store.getters["auth/access_token"];

    const user = store.getters["auth/user"];

    if (
        user &&
        user["custom:tenant_id"] &&
        (process.env.VUE_APP_API_MODE === "prod" ||
            process.env.VUE_APP_API_MODE === "pre") &&
        request.baseURL !== process.env.VUE_APP_API_AUTH &&
        request.baseURL !== process.env.VUE_APP_API_CORE &&
        request.baseURL !== process.env.VUE_APP_LANGS_BUCKET &&
        request.baseURL !== process.env.VUE_APP_API_SASS &&
        request.baseURL != baseURL + "/" + user["custom:tenant_id"] &&
        !request.baseURL.startsWith("http://localhost") &&
        !/https:\/\/.*.s3.*.amazonaws.com/.test(request.baseURL)
    ) {
        request.baseURL = request.baseURL + "/" + user["custom:tenant_id"];
    }
    if (token && !request.baseURL.includes("s3")) {
        request.headers.common["Authorization"] = `Bearer ${token}`;
    }
    if (token && request.baseURL === process.env.VUE_APP_API_SASS) {
        const [IdToken, AccessToken, RefreshToken] = token.split("|");
        request.headers.common["Authorization"] = `Bearer ${AccessToken}`;
    }
    return request;
});

// Response interceptor
axios.interceptors.response.use(
    (response) => {
        /* const { data } = response;
    if (!data.success && data.statusCode === 404) {
        console.log("404");
        router.push({path: '/us/login'});
    } */
        return Promise.resolve(response);
    },
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        if (
            store.getters["auth/user"] === null ||
            (store.getters["auth/user"] &&
                store.getters["auth/user"]["custom:tenant_id"] === null)
        ) {
            store.commit("auth/LOGOUT");
            router.push({ name: "login" });
        }

        const { status, data } = error.response;
        if (status >= 500) {
            Swal.fire({
                type: "error",
                title: i18n.t("error_alert_title"),
                text: i18n.t("error_alert_text"),
                reverseButtons: true,
                confirmButtonText: i18n.t("ok"),
                cancelButtonText: i18n.t("cancel"),
            });
        }
        if (status === 401 && data.message !== "Unauthorized Role") {
            if (store.state.idleVue.isIdle) {
                Swal.fire({
                    type: "warning",
                    title: i18n.t("token_expired_alert_title"),
                    text: i18n.t("token_expired_alert_text"),
                    reverseButtons: true,
                    confirmButtonText: i18n.t("ok"),
                    cancelButtonText: i18n.t("cancel"),
                }).then(() => {
                    store.commit("auth/LOGOUT");
                    router.push({ name: "login" });
                });
            } else {
                if (
                    store.getters["auth/user"] &&
                    store.getters["auth/user"]["email"]
                ) {
                    if (store.getters["auth/authTried"] < 3) {
                        store.dispatch("auth/addAuthTried");
                        return refreshToken(store).then((_) => {
                            const token = store.getters["auth/access_token"];
                            if (token) {
                                error.config.headers[
                                    "Authorization"
                                ] = `Bearer ${token}`;
                            }
                            return axios.request(error.config);
                        });
                    }
                }
                store.commit("auth/LOGOUT");
                router.push({ name: "login" });
            }
        }

        return Promise.reject(error);
    }
);
//Generar cokkie o storage para guardar el email.
//La primera vez si que refresca bien, pero deja la cookie como undefined y al siguiente ya no lo hace al estar undefined
function refreshToken(store) {
    const refreshingCall = axios
        .post(
            "refresh-token",
            {
                //email: Cookies.get("ACCOUNT_EMAIL"), Cuando vuelve a generar la cookie guarda un undefined
                email: store.getters["auth/user"]["email"],
            },
            {
                baseURL: process.env.VUE_APP_API_AUTH,
            }
        )
        .then(({ data }) => {
            if (data.success) {
                store.dispatch("auth/saveToken", { ...data });
            }
            return Promise.resolve(true);
        });
    return refreshingCall;
}
